import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" fill=\"currentColor\" id=\"minus\">\n  <path d=\"M200,-182 C209.941125,-182 218,-173.941125 218,-164 L218,200 C218,209.941125 209.941125,218 200,218 C190.058875,218 182,209.941125 182,200 L182,-164 C182,-173.941125 190.058875,-182 200,-182 Z\" transform=\"rotate(90 111.5 161.5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol